"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  getHubUrl,
  parseReportTypeFromPathname,
} from "./(site)/[lang]/[reportType]/explore/_lib/explore-routes";

export function NotFoundContent() {
  const pathname = usePathname();
  const reportType = parseReportTypeFromPathname({ pathname });
  const hubUrl = getHubUrl({ reportType });

  return (
    <>
      <header
        className="sticky top-0 z-50 border-[var(--explore-border-light)] border-b bg-[var(--explore-bg-card)]"
        style={{ fontFamily: "var(--homepage-sans-stack)" }}
      >
        <div className="mx-auto flex max-w-[1320px] items-center px-4 py-2 sm:px-6 sm:py-3">
          <Link className="flex items-center gap-2 no-underline" href={hubUrl}>
            <Image
              alt="AI Primer"
              className="h-[30px] w-[30px] rounded-full sm:h-[34px] sm:w-[34px]"
              height={34}
              src="/logo.webp"
              width={34}
            />
            <span className="whitespace-nowrap font-bold text-[0.9rem] text-[var(--explore-text-primary)] sm:text-[1.05rem]">
              AI Primer
            </span>
          </Link>
        </div>
      </header>

      <main
        className="flex flex-1 flex-col items-center justify-center px-4 py-16"
        id="main-content"
        tabIndex={-1}
      >
        <Image
          alt="Two people sitting on a couch with laptops showing 404 errors"
          className="mb-10 w-full max-w-2xl rounded-lg"
          height={500}
          priority
          src="/404-illustration.png"
          width={900}
        />

        <h1
          className="mb-8 max-w-2xl text-center font-semibold text-[1.55rem] leading-tight sm:text-[2.15rem]"
          style={{
            fontFamily: "var(--explore-card-title-stack)",
            color: "var(--explore-text-primary)",
          }}
        >
          Oh no! You found a non-existing page!
        </h1>

        <Link
          className="rounded-full px-8 py-3 font-semibold text-sm no-underline transition-opacity hover:opacity-90"
          href={hubUrl}
          style={{
            backgroundColor: "var(--explore-accent-yellow)",
            color: "var(--explore-on-accent-text)",
            fontFamily: "var(--homepage-sans-stack)",
          }}
        >
          Go home
        </Link>
      </main>
    </>
  );
}
